import { reactive } from 'vue';

export const formState = reactive({
    completeRequirementDept: {
        value: null,
        show: false,
        disabled: false,
    },
    deliveryDate: {
        value: null,
        show: false,
        disabled: false,
    },
    deliveryFile: {
        value: null,
        show: false,
        disabled: false,
    },
    demander: {
        value: null,
        show: false,
        disabled: false,
    },
    demanderDept: {
        value: null,
        show: false,
        disabled: false,
    },
    demanderDeptHead: {
        value: null,
        show: false,
        disabled: false,
    },
    demanderId: {
        value: null,
        show: false,
        disabled: false,
    },
    executor: {
        value: null,
        show: false,
        disabled: false,
    },
    executorId: {
        value: null,
        show: false,
        disabled: false,
    },
    expectedDeliveryDate: {
        value: null,
        show: false,
        disabled: false,
    },
    id: {
        value: null,
        show: false,
        disabled: false,
    },
    isDelivery: {
        value: null,
        show: false,
        disabled: false,
    },
    isPush: {
        value: null,
        show: false,
        disabled: false,
    },
    isReceive: {
        value: null,
        show: false,
        disabled: false,
    },
    notes: {
        value: null,
        show: false,
        disabled: false,
    },
    progress: {
        value: null,
        show: false,
        disabled: false,
    },
    proposedTime: {
        value: null,
        show: false,
        disabled: false,
    },
    pushDate: {
        value: null,
        show: false,
        disabled: false,
    },
    receiveDate: {
        value: null,
        show: false,
        disabled: false,
    },
    requirementContent: {
        value: null,
        show: false,
        disabled: false,
    },
    requirementDeliveryConfirmation: {
        value: null,
        show: false,
        disabled: false,
    },
    requirementFile: {
        value: null,
        show: false,
        disabled: false,
    },
    requirementName: {
        value: null,
        show: false,
        disabled: false,
    },
});

const checkStringRule = async (rule, value) => {
    if (!value.value && rule.required) {
        return Promise.reject(rule.message);
    }
    return Promise.resolve();
};

const checkBooleanRule = async (rule, value) => {
    if (value.value === false || value.value === true) {
        return Promise.resolve();
    }
    return Promise.reject(rule.message);
};

export const rules = reactive({
    requirementName: [
        {
            required: true,
            message: "请输入需求名称",
            trigger: "change",
            validator: checkStringRule,
        },
    ],
    requirementContent: [
        {
            required: true,
            message: "请输入需求内容",
            trigger: "change",
            validator: checkStringRule,
        },
    ],
    expectedDeliveryDate: [
        {
            required: true,
            message: "请选择期望交付日期",
            trigger: "change",
            validator: checkStringRule,
        },
    ],

    completeRequirementDept: [
        {
            required: true,
            message: "请选择完成需求部门",
            trigger: "change",
            validator: checkStringRule,
        },
    ],
    isReceive: [
        {
            required: true,
            message: "请选择需求是否接收",
            trigger: "change",
            validator: checkBooleanRule,
        },
    ],
    executor: [
        {
            required: false,
            message: "请选择任务负责人",
            trigger: "change",
            validator: checkStringRule,
        },
    ],
    isDelivery: [
        {
            required: true,
            message: "请选择交付",
            trigger: "change",
            validator: checkBooleanRule,
        },
    ],
    requirementDeliveryConfirmation: [
        {
            required: true,
            message: "请选择交付确认",
            trigger: "change",
            validator: checkStringRule,
        },
    ]
});
